var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#EA7000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9952 7.34729C18.366 6.97647 18.366 6.37526 17.9952 6.00444V6.00444C17.6243 5.63362 17.0231 5.63362 16.6523 6.00444L11.9999 10.6568L7.34754 6.00444C6.97672 5.63362 6.3755 5.63362 6.00468 6.00444V6.00444C5.63386 6.37526 5.63386 6.97647 6.00468 7.34729L10.6571 11.9997L6.00468 16.6521C5.63386 17.0229 5.63386 17.6241 6.00468 17.9949V17.9949C6.3755 18.3657 6.97672 18.3657 7.34754 17.9949L11.9999 13.3425L16.6523 17.9949C17.0231 18.3657 17.6243 18.3657 17.9952 17.9949V17.9949C18.366 17.6241 18.366 17.0229 17.9952 16.6521L13.3428 11.9997L17.9952 7.34729Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointError);
export default __webpack_public_path__ + "static/media/point-error.621f7663c34a70591a47650596ebd373.svg";
export { ForwardRef as ReactComponent };